export default "__VITE_ASSET__DZIyv1VT__"